// extracted by mini-css-extract-plugin
export var bottomBar = "index-module--bottomBar--5dRAa";
export var bottomBar__content = "index-module--bottomBar__content--glT7k";
export var bottomBar__logo = "index-module--bottomBar__logo--sSIDW";
export var canvas = "index-module--canvas--v29xk";
export var canvas__header = "index-module--canvas__header--jqdsE";
export var frameLayout = "index-module--frameLayout--7jn6e";
export var gradient = "index-module--gradient--Ciwsj";
export var topBar = "index-module--topBar--EYiz7";
export var topBar__logo = "index-module--topBar__logo--zudqG";